
import { Component, Prop, Vue } from "nuxt-property-decorator";
import EsyCard from "~/components/atoms/sectioning/EsyCard.vue";
import EsyCardContent from "~/components/atoms/sectioning/EsyCardContent.vue";
import DeliveryOptionsList from "~/components/molecules/display/deliveryOptionList/DeliveryOptionList.vue";
import DeliveryOptionsListItem from "~/components/molecules/display/deliveryOptionList/DeliveryOptionListItem.vue";
import { Common, DeliveryTruck } from "~/operations/messages";
import { DeliveryOptionsForDisplay } from "~/types/DeliveryOptions";
import { PartnerType } from "~/types/Partner";

@Component({
  components: {
    EsyCard,
    EsyCardContent,
    DeliveryOptionsList,
    DeliveryOptionsListItem,
  },
})
export default class DeliveryOptionsCard extends Vue {
  @Prop() deliveryOptions: DeliveryOptionsForDisplay;
  @Prop() dealerType: PartnerType;

  commonTexts = Common;
  deliveryVehicleTexts = DeliveryTruck;

  get isHeatingOilDealer(): boolean {
    return this.dealerType === "PARTNER";
  }

  get isPelletDealer(): boolean {
    return this.dealerType === "PARTNER_PELLET";
  }
}
